import { today, createDurationFromObject, getSafeDateTime } from 'helpers/date';
import { INVALID_DATE_RANGE, DATE_RANGE_TOO_SHORT, DATE_RANGE_TOO_LONG } from 'constants/errors';
import { DateRangeModel } from 'forms/shared/types';
import { BaseCustomValidator } from '../types';
import { EmptyDateRangeInstance } from '../../models/dateRange/instance';

const dateRangeBaseValidator: BaseCustomValidator<DateRangeModel> = (validateModel) => (
  value = EmptyDateRangeInstance,
  options,
  key,
  attributes,
  globalOptions
) => {
  const { from, present } = value;
  const to = present ? today.toObject() : value.to;

  const dateErrors = validateModel(
    { from, to },
    {
      from: { presence: true, date: true },
      to: { presence: true, date: true },
    },
    { ...globalOptions, ...options }
  );

  if (dateErrors !== true) { return dateErrors; }

  const fromDateObj = getSafeDateTime(from);
  const toDateObj = getSafeDateTime(to);

  if (fromDateObj.valid === false || toDateObj.valid === false) { return INVALID_DATE_RANGE; }

  if (toDateObj.datetime >= fromDateObj.datetime) {
    const { minDuration, maxDuration } = options;
    if (minDuration || maxDuration) {
      // validate the diff
      const durationUnit = 'days';
      const rangeDiff = toDateObj.datetime.diff(fromDateObj.datetime, durationUnit).as(durationUnit);

      const min = createDurationFromObject(minDuration ?? {});
      if (minDuration && typeof min !== 'number' && min.as(durationUnit) > rangeDiff) {
        return DATE_RANGE_TOO_SHORT;
      }

      const max = createDurationFromObject(maxDuration ?? {});
      if (maxDuration && typeof max !== 'number' && max.as(durationUnit) < rangeDiff) {
        return DATE_RANGE_TOO_LONG;
      }
    }

    return null;
  }

  return 'error.daterange.order';
};

export default dateRangeBaseValidator;
